module.exports = __webpack_public_path__ + "static/img/preview.399a201.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/nivea-100-year-sweepstakes-microsite/preview.png
// module id = 105
// module chunks = 2